import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "merge",
  "use": "merge-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"merge\"><path d=\"m17.07 3.5 1.43 1.418-3.458 3.428-1.43-1.418zM7.437 15.976h3.549v-5.62L5.5 4.918 6.93 3.5l6.084 6.032v6.444h3.55L12 20.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol